<template>
  <div
    class="coin-shadow w-16 h-16 lg:w-20 lg:h-20 rounded-2xl bg-white flex-y-center justify-center p-3"
    :class="[rotatePosition === 'left' ? '-rotate-12' : 'rotate-12']"
  >
    <img
      :src="image"
      alt="Coin"
      class="w-full h-full object-cover"
      loading="lazy"
    />
  </div>
</template>

<script setup lang="ts">
interface Props {
  image: string;
  rotatePosition: "left" | "right";
}
defineProps<Props>();
</script>

<style scoped>
.coin-shadow {
  -webkit-box-shadow: 0px 2px 54px -1px rgba(34, 60, 80, 0.2);
  -moz-box-shadow: 0px 2px 54px -1px rgba(34, 60, 80, 0.2);
  box-shadow: 0px 2px 54px -1px rgba(34, 60, 80, 0.2);
}
</style>
